import { render } from "./CourseDetailsForm.vue?vue&type=template&id=41798220"
import script from "./CourseDetailsForm.vue?vue&type=script&lang=js"
export * from "./CourseDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__